import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { CLEANER } from './mock-users';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { Router } from "@angular/router";
import * as moment from 'moment';
import { getAcronym, getOfficeName } from '../globals';
import { LoaderService } from '../common/loadingBar/loader.service';


@Injectable()
export class ServicesService extends AuthService{
    private URLListServices = "manager/service?date_min=:dateMin&date_max=:dateMax";
    private URLGetAssignServices = "manager/service/without-assign";
    private URLSearchServices = "manager/service/search";
    private URLSendToApp = "manager/service/:ID/add-to-app";
    private URLSendToAppProf = "manager/service/:ID/professional/:IDPROF/send-to-professional-app";
    private URLRemoveFromApp = "manager/service/:ID/remove-from-app";
    private URLRemoveToAppPRof = "manager/service/:ID/remove-from-professional-app";
    private URLGetCommentsResume = "manager/service/:ID/comment-resume";
    private DATEMIN = ":dateMin";
    private DATEMAX = ":dateMax";
    private ID = ":ID";
    private IDPROF = ":IDPROF"
    private availability: Array<object> = [];

    constructor(public http: Http, public router: Router, private loaderService: LoaderService) {
        super(http, router);
    }

    public getServices(dateMin: string, dateMax: string) {
        let URLListServices = this.URLListServices.replace(this.DATEMIN, dateMin).replace(this.DATEMAX, dateMin);
        return this.http.get(this.APIURL + URLListServices ,{headers: this.headers})
        .flatMap((res: Response) => {
            return res.json()["response"];
        })
        .filter(service => {
            this.parseService(service);
            return true;
        }); 
    }

    public getAssignServices() {
        this.loaderService.show();
        return this.http.get(this.APIURL + this.URLGetAssignServices ,{headers: this.headers})
        .map((res: Response) => {
            this.loaderService.hide();
            return this.parseAssignService(res.json()["response"]);
        }); 
    }
    
    public searchServices(filter: any) {
        this.loaderService.show();
        return this.http.post(this.APIURL + this.URLSearchServices , filter, {headers: this.headers})
        .flatMap((res: Response) => {
            this.loaderService.hide();
            return res.json()["response"]
        })
        .filter(service => {
            this.parseService(service);
            return true;
        }); 
    }
    
    public getCommentsResume(id: string) {
        let URLGetCommentsResume = this.URLGetCommentsResume.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetCommentsResume ,{headers: this.headers})
        .map((res: Response) => {
            return res.json()["response"];
        })
        .filter(comments => {
            this.parseComments(comments["allComments"]);
            return true;
        })
    }

    public sendToApp(id: string) {
        let URLSendToApp = this.URLSendToApp.replace(this.ID, id);
        return this.http.put(this.APIURL + URLSendToApp , null, {headers: this.headers})
        .map((res: Response) => {
            //this.loaderService.hide();
            return res.json()["status"];
        });
    }

    public sendToAppWithProf(id: string, idProf: string) {
        let URLSendToAppProf = this.URLSendToAppProf.replace(this.ID, id).replace(this.IDPROF, idProf);
        return this.http.put(this.APIURL + URLSendToAppProf , null, {headers: this.headers})
        .map((res: Response) => res.json()["status"]);
        
    }

    public removeFromApp(id: string) {
        let URLRemoveFromApp = this.URLRemoveFromApp.replace(this.ID, id);
        return this.http.put(this.APIURL + URLRemoveFromApp , null, {headers: this.headers})
        .map((res: Response) => {
            return res.json()["status"];
        });
    }

    public removeFromAppProf(id: string) {
        let URLRemoveToAppPRof = this.URLRemoveToAppPRof.replace(this.ID, id);
        return this.http.put(this.APIURL + URLRemoveToAppPRof , null, {headers: this.headers})
        .map((res: Response) => {
            return res.json()["status"];
        });
    }

    private parseService(service: object):void {
        var integer = parseInt(service["n_hours"]);
        var decimals = service["n_hours"] - integer;
        var dateParsed = service["date"];
        var minutes = (decimals == 0) ? ":00" : ":30";
        service["date"] = moment(service["date"],"YYYY-MM-DD").format("DD/MM/YYYY");
        var time_end = moment(service["time_ini"],"HH:mm");
        time_end.add(parseFloat(service["n_hours"]),"hours");
        service["time_end"] = time_end.format("HH:mm");
        service["n_hours"] = integer + minutes;
        service["now"] = moment().format("HH:mm");
        service["today"] = moment().format("YYYY-MM-DD");   
        service["isAfter"] = moment(dateParsed).isAfter(service["today"]);
        service["isSame"] = moment(dateParsed).isSame(service["today"]);
        service["isBefore"] = moment(dateParsed).isBefore(service["today"]);
        service["acronym"] = getOfficeName(service["id_clintu_office"]);
        
    }

    private parseComments(comments) {
       comments.forEach((comment, index) => {
           comment["date"] = moment(comment["ins_date"]).format("DD/MM/YYYY HH:mm");
       });
       comments.reverse();
    }


    private parseAssignService(services: Array<object>):Array<object> {
        var date;
        var arrayAssign = []
        var object = {
            date: "",
            services: []
        };
        for (var index = 0; index < services.length; index++) {
             var element = services[index];
             element["date"] = moment(element["date"],"YYYY-MM-DD").format("DD/MM/YYYY");
             element["acronym"] = getOfficeName(element["id_clintu_office"]);

             if(index == 0){
                date = element["date"];
                object["date"] = date;
            }
            if(date == element["date"]){
                object["services"].push(element)
            }else{
                arrayAssign.push(object);
                date = element["date"];
                object = {
                    date: date,
                    services: []
                };
                object["services"].push(element);
                
            }
            if(index == services.length - 1){
                arrayAssign.push(object);
            }
        }
        return arrayAssign
    }
}


// WEBPACK FOOTER //
// ./src/app/injections/services.service.ts